import { render, staticRenderFns } from "./MemberShipList.vue?vue&type=template&id=679d53f8&scoped=true&"
import script from "./MemberShipList.vue?vue&type=script&lang=js&"
export * from "./MemberShipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d53f8",
  null
  
)

export default component.exports